import * as React from "react"
import PropTypes from "prop-types"

import Header from "../header/header"
import Footer from "../footer/footer"

const Layout = ({ children }) => (
  <>
    <Header />
    <div>
      <main>
        {children}
      </main>
    </div>
    <Footer />
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout